import { render, staticRenderFns } from "./MyReservationDetails.vue?vue&type=template&id=1af7dd9e&scoped=true&"
import script from "./MyReservationDetails.vue?vue&type=script&lang=js&"
export * from "./MyReservationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af7dd9e",
  null
  
)

export default component.exports